import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './VideoBackground.css';

const VideoBackground = ({ videoUrl, children }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays on mount
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        // Autoplay was prevented, which is expected in some browsers
        console.log('Autoplay prevented:', error);
      });
    }
  }, []);

  return (
    <div className="video-background">
      <div className="video-background-overlay"></div>
      <video
        ref={videoRef}
        className="video-background-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-background-content">
        {children}
      </div>
    </div>
  );
};

VideoBackground.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default VideoBackground;
